export const JsonLd = ({ data, id }) => (
  <script
    type="application/ld+json"
    data-jsonld={id}
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);
